"use client";

import React, { type ComponentProps, type RefObject } from "react";
import { useSticky } from "@frend-digital/ui/hooks";
import { Slot } from "./Slot";

export const StickyTracker = ({
	asChild,
	children,
	...rest
}: ComponentProps<"div"> & {
	asChild?: boolean;
}) => {
	const [ref, sticky] = useSticky();
	const Component = asChild ? Slot : "div";
	return (
		<Component
			{...rest}
			ref={ref as RefObject<HTMLDivElement>}
			data-sticky={sticky ? true : undefined}
		>
			{children}
		</Component>
	);
};
